import PromoUpdate from './PromoUpdate'
export {PromoUpdate}
export default PromoUpdate
